export default __webpack_public_path__ + "static/typography-image-v-49574a99543e5951b5baccab67f53e56.png";